import { TypedJsonResponse } from '../apiClientUtils';
import { MeDto } from './authApiTypes';

export interface AuthApiClientConfig {
  baseUrl: string;
  fetcher?: typeof fetch;
}

export function createAuthApiClient({
  baseUrl,
  fetcher: fetch = window.fetch,
}: AuthApiClientConfig) {
  return {
    get baseUrl() {
      return baseUrl;
    },
    async getMe() {
      return (await fetch(`${baseUrl}/users/me`, {
        credentials: 'include',
      })) as TypedJsonResponse<MeDto>;
    },

    async login({
      username,
      password,
    }: {
      username: string;
      password: string;
    }) {
      return await fetch(`${baseUrl}/authenticate/login`, {
        body: JSON.stringify({ username, password }),
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
      });
    },

    async loginAs({ username }: { username: string }) {
      return await fetch(
        `${baseUrl}/authenticate/login-as` +
          `?foreignEmail=${encodeURIComponent(username)}`,
        {
          credentials: 'include',
        },
      );
    },

    async logout() {
      return await fetch(`${baseUrl}/authenticate/logout`, {
        credentials: 'include',
      });
    },

    async refreshToken() {
      return await fetch(`${baseUrl}/authenticate/refresh-token`, {
        credentials: 'include',
        method: 'POST',
      });
    },
  };
}

export type AuthApiClient = ReturnType<typeof createAuthApiClient>;
